<template>
  <div :class="$style.root">
    <div
      v-for="item in internalLegend"
      :key="item.desc"
      :class="$style.item"
    >
      <UiButton
        :depressed="true"
        tag="div"
        v-bind="item.button"
      >
        <DayButtonContent
          :theme="item.iconName"
        />
      </UiButton>
      <span :class="$style.description">
            {{ item.desc }}
      </span>
    </div>
  </div>
</template>

<script>
  import { KEYS_MAP } from '@/constants/calendar';
  import UiButton from '@/components/UiButton';
  import DayButtonContent from '@/components/CalendarLessons/DayButtonContent';

  export default {
    name: 'LegendList',
    components: {
      UiButton,
      DayButtonContent,
    },
    props: {
      legend: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      /**
       * @TODO: move to API mappers
       */
      internalLegend() {
        return this.legend.map((item) => {
          const { desc } = item;
          const iconName = KEYS_MAP[desc] ?? null;
          return {
            desc,
            iconName,
            ...!iconName && {
              ...item,
            },
          };
        });
      },
    },
  };
</script>

<style lang="scss" module>
  .root {
    opacity: 0.3;
    display: grid;
    grid-template-columns: repeat(4, auto);
    width: 75%;
    margin-top: 0!important;
    @include media('xs') {
      grid-template-columns: repeat(2, auto);
      margin-bottom: 32px;
      width: 100%;
    }

    @include mediaMin('sm') {
      margin-bottom: 16px;
    }
  }

  .item {
    display: flex;
    align-items: center;
    margin-right: 25px;
    @include media('xs') {
      margin-bottom: 8px;
    }

    @include mediaMin('sm') {

      margin-bottom: 16px;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  .description {
    margin-left: 25px;
    @include typography(13px, 15px);
    font-weight: 500;
    position: relative;
  }
</style>
